import { render, staticRenderFns } from "./CampaignDatesList.vue?vue&type=template&id=7bc3a03e&"
import script from "./CampaignDatesList.vue?vue&type=script&lang=js&"
export * from "./CampaignDatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports